import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1eab2143"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "live-wrapper"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 1
};
const _hoisted_4 = {
  class: "lecture-live-box"
};
const _hoisted_5 = {
  key: 0,
  id: "lecture-video"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "playback-list"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "playback-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("section", _hoisted_1, [$props.liveStatus == -2 && $props.liveUrl ? (_openBlock(), _createElementBlock("iframe", {
    key: 0,
    src: $props.liveUrl,
    frameborder: "0",
    class: "live-iframe"
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), $props.liveStatus > 1 && $props.playback ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$data.isVideo ? (_openBlock(), _createElementBlock("div", _hoisted_5)) : (_openBlock(), _createElementBlock("iframe", {
    key: 1,
    src: $data.currentPlaybackUrl,
    class: "video-iframe",
    frameborder: "0"
  }, null, 8, _hoisted_6))]), _createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.playbackList, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass(["playback-item", {
        'playback-item-active': index === $data.currentIndex
      }]),
      key: index,
      onClick: $event => $options.handlePlayback(item, index)
    }, [_createElementVNode("i", {
      class: _normalizeClass(["iconfont icon-huifang playback-icon", {
        iconhuifang: index === $data.currentIndex
      }])
    }, null, 2), _createElementVNode("span", _hoisted_9, _toDisplayString('回放视频' + $data.numList[index]), 1)], 10, _hoisted_8);
  }), 128))])])) : _createCommentVNode("", true)]);
}